// dialog.tokens.ts
import { InjectionToken } from '@angular/core';

export const SEARCH_DIALOG_COMPONENT = new InjectionToken<any>('SEARCH_DIALOG_COMPONENT');
